import { useEffect, useState } from "react";
import BreadCrumbWrapper from "components/global/BreadCrumbs/BreadCrumbs";
import OrganizationsList from "components/global/OrganizationsList/OrganizationsList";
import organizationsListSignal from "components/global/OrganizationsList/OrganizationsList.signal";
import { useLocation } from "react-router-dom";
import $appSettings from "signals/AppSettings.signal";
import { canPerformAction } from '../../../../../libs/programAccessPermissions';
import userAccountSignal from '../../../../../signals/UserAccount.signal';
import api from '../../../../../api/api';
import loaderSignal from '../../../../../signals/Loader.signal';

const EdoLenderProgramMembershipDetail = () => {
  const location = useLocation();
  const { fundingProgram, lender } = organizationsListSignal.value;
  const { PORTAL_TYPES } = $appSettings.value.constants;
  const [canViewMaintenance, setCanViewMaintenance] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  let labels = [];

  if (location.pathname.startsWith('/edo/programs')) {
    labels = [
      '',
      !!fundingProgram ? fundingProgram.name : '',
      !!fundingProgram ? `Businesses enrolled in ${fundingProgram.name}` : '',
    ];
  } else {
    labels = [
      '',
      !!lender ? lender.name : '',
      !!fundingProgram ? `Businesses enrolled in ${fundingProgram.name}` : '',
    ];
  }

  // Check if user has canViewMaintenance permission on any program
  useEffect(() => {
    const checkViewMaintenancePermission = async () => {
      try {
        loaderSignal.update({ isContentLoading: true });
        // Fetch funding programs for the EDO
        const fundingPrograms = await api.get({
          path: '/fundingPrograms',
          options: {
            where: {
              edoId: userAccountSignal.value.userData?.account.edoId,
            },
          },
        });

        if (!fundingPrograms || fundingPrograms.length === 0) {
          setCanViewMaintenance(false);
          setIsChecking(false);
          return;
        }

        // Check if user has canViewMaintenance permission on any program
        const viewChecks = await Promise.all(
          fundingPrograms.map((program) =>
            canPerformAction(program.id, 'canViewMaintenance')
          )
        );

        setCanViewMaintenance(viewChecks.some((hasPermission) => hasPermission));
      } catch (error) {
        console.error('Error checking view maintenance permission:', error);
        setCanViewMaintenance(false);
      } finally {
        setIsChecking(false);
        loaderSignal.reset();
      }
    };

    checkViewMaintenancePermission();
  }, []);

  if (isChecking) {
    return (
      <BreadCrumbWrapper labels={labels}>
        <div className="border border-gray shadow-sm bg-white p-40">
          <p className="text-center">Loading...</p>
        </div>
      </BreadCrumbWrapper>
    );
  }

  if (!canViewMaintenance) {
    return (
      <BreadCrumbWrapper labels={labels}>
        <div className="border border-gray shadow-sm bg-white p-40">
          <h3 className="text-center">Access Denied</h3>
          <p className="text-center">
            You do not have permission to view program membership details.
          </p>
        </div>
      </BreadCrumbWrapper>
    );
  }

  return (
    <BreadCrumbWrapper
      labels={labels}
    >
      <div className="border border-gray shadow-sm bg-white p-40">
        <OrganizationsList
          portalType={PORTAL_TYPES.business}
          tableTitle="Enrolled Businesses"
          newPath={`${location.pathname}/business`}
        />
      </div>
    </BreadCrumbWrapper>
  );
}


export default EdoLenderProgramMembershipDetail;
